import './FailuresTextBox.css'

import React from 'react'
import { FailureResponse, HitsData } from '@/pages/communal/statistics/components/common/data'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useTranslations } from '@/hooks/useTranslations'
import { HitText } from '@/components/hit/HitText'

type FailuresStatusBoxProps = {
  services: Services
  session: CurrentSession
  failures: FailureResponse
  hits: HitsData | undefined

  onMaxHitsClick?: () => void
  onAvgHitsClick?: () => void
  onServicemanCounterClick?: () => void
  onUserCounterClick?: () => void
  onTotalHitsClick?: () => void
}

export const FailuresTextBox = ({ services, session, failures, hits, onMaxHitsClick, onAvgHitsClick, onServicemanCounterClick, onUserCounterClick, onTotalHitsClick }: FailuresStatusBoxProps) => {
  const translates = useTranslations(services, session)

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  const maxHit: number = hits ? Math.max(hits.maxHitX, hits.maxHitY, hits.maxHitZ) : 0;

  return <div className="communal-userstatistic-failurestext-box">
    <div className="text-stat" onClick={() => onServicemanCounterClick && onServicemanCounterClick()}>
      <h3 className="text-title">
        {translates.for('page.statistics.global.box.failurestext.serviceman_counter')}
      </h3>
      <span className="text-value">
        {failures.servicemanFailuresCount}
      </span>
    </div>
    <div className="text-stat" onClick={() => onUserCounterClick && onUserCounterClick()}>
      <h3 className="text-title">
        {translates.for('page.statistics.global.box.failurestext.user_counter')}
      </h3>
      <span className="text-value">
        {failures.userFailuresCount}
      </span>
    </div>
    {hits ? <>
      <div className="text-stat" onClick={() => onTotalHitsClick && onTotalHitsClick()}>
        <h3 className="text-title">
          {translates.for('page.statistics.global.box.failurestext.total_hits')}
        </h3>
        <span className="text-value">
          {hits.totalHits}
        </span>
      </div>
      <div className="text-stat" onClick={() => onMaxHitsClick && onMaxHitsClick()}>
        <h3 className="text-title">
          {translates.for('page.statistics.global.box.failurestext.max_hit')}
        </h3>
        <span className="text-value">
          <HitText value={maxHit}>{maxHit.toFixed(2)}</HitText>
          {}
        </span>
      </div>
      <div className="text-stat" onClick={() => onAvgHitsClick && onAvgHitsClick()}>
        <h3 className="text-title">
          {translates.for('page.statistics.global.box.failurestext.avg_hit')}
        </h3>
        <span className="text-value">
          <HitText value={hits.avgHit}>{hits.avgHit.toFixed(2)}</HitText>
        </span>
      </div>
    </> : null}
  </div>
}